// extracted by mini-css-extract-plugin
export default {"noProductsMessageContainer":"style--noProductsMessageContainer--ebc7c5"};